import theme from '@src/theme/theme';

import { MarketplaceOrderStatus } from '@dto/fusion/fusion.dto';

export const MarketplaceOrderStatusTitle: Record<
  MarketplaceOrderStatus,
  string
> = {
  [MarketplaceOrderStatus.Create]: 'Created',
  [MarketplaceOrderStatus.Update]: 'Updated',
  [MarketplaceOrderStatus.Buy]: 'Sold',
  [MarketplaceOrderStatus.Cancel]: 'Canceled',
};

export const MarketplaceOrderStatusColor = {
  [MarketplaceOrderStatus.Create]: theme.palette.custom.tags.mint,
  [MarketplaceOrderStatus.Update]: theme.palette.custom.tags.processing,
  [MarketplaceOrderStatus.Buy]: theme.palette.custom.tags.success,
  [MarketplaceOrderStatus.Cancel]: theme.palette.custom.tags.reject,
};

export enum OrderUpdateTableAction {
  Bought,
  Sold,
}

export const OrderUpdateTableActionTitle: Record<
  OrderUpdateTableAction,
  string
> = {
  [OrderUpdateTableAction.Bought]: 'Bought',
  [OrderUpdateTableAction.Sold]: 'Sold',
};

export const OrderUpdateTableActionColor = {
  [OrderUpdateTableAction.Bought]: theme.palette.custom.tags.success,
  [OrderUpdateTableAction.Sold]: theme.palette.custom.tags.processing,
};

export const DEBANK_LINK = 'https://debank.com/profile';

export const SELLER_MARKETPLACE_FEE = 3;
export const BUYER_MARKETPLACE_FEE = 3;
export const MAX_MARKETPLACE_PRICE_PER_ONE = 1000;

export const FAQ = [
  {
    title: 'What is EMP Fusion?',
    value:
      'EMP Fusion is a simplified staking protocol that unites all revenue streams across the EMP ecosystem. By staking a Microgrid, you earn a share of real, protocol-generated yield from every project built under the EMP banner. This is distributed proportionally between all Microgrids, so the more you own, the larger percentage of yield you receive.',
  },
  {
    title: 'How do I get started?',
    value:
      'To join, purchase a Microgrid from the EMP Fusion Marketplace — the only way to access the protocol. Once you own a Microgrid, stake it, and you’ll automatically start earning yield distributed every block.',
  },
  {
    title: 'What is a Microgrid?',
    value:
      'A Microgrid is a NFT that represents ownership and participation in the EMP ecosystem. There is a fixed supply of Microgrids, meaning each holder owns a limited and permanent share of the network’s revenue distribution.',
  },
  {
    title: 'Why is there a fixed supply of Microgrids?',
    value:
      "The fixed supply ensures fairness, scarcity, and true ownership. No new Microgrids will ever be created, which means your share of the ecosystem cannot be diluted over time. The system automatically purchases Microgrids off the marketplace to increase current holders' ownership automatically.",
  },
  {
    title: 'Where does the yield come from?',
    value:
      'All rewards are generated by real revenue from EMP’s ecosystem — including products like DexVaults, Treasury Bonds, and all future implementations. The system distributes a portion of these profits back to Microgrid holders through the Fusion protocol in a completely decentralized manner.',
  },
  {
    title: 'What do I earn by staking my Microgrid?',
    value:
      'You earn a proportional share of the total yield generated by the EMP ecosystem. Rewards are variable and paid through the fixed supply utility token Eshare. This means direct buying pressure on Eshare from real revenue, that is then distributed, and can be sold into any other assets.',
  },
  {
    title: 'Can I sell or transfer my Microgrid?',
    value:
      'Yes. Microgrids can be freely bought or sold on the EMP Fusion Marketplace, allowing you to enter or exit the ecosystem at any time. Market demand determines pricing and value. There is a 3% Marketplace fee on all buys, sells and transfers.',
  },
  {
    title: 'Is EMP Fusion decentralized?',
    value:
      'Yes. Fusion is built on fully on-chain smart contracts that automate yield distribution and ownership verification. There are no intermediaries — all ownership and rewards are handled transparently on the blockchain.',
  },
  {
    title: 'What makes EMP Fusion different from other staking platforms?',
    value:
      'EMP Fusion doesn’t rely on inflationary tokens or unsustainable reward loops. It’s powered entirely by real, protocol-generated revenue, making it a simple, transparent, and long-term way to participate in DeFi growth. You earn passively regardless of market conditions.',
  },
  {
    title: 'What risks should I be aware of?',
    value:
      'As with any DeFi protocol, there are inherent smart contract and market risks. Always verify contract addresses, understand how rewards are generated, and use only official EMP Fusion links and documentation. Nothing is guaranteed, and the protocol operates with no expectation of profit from the work of others.',
  },
];

export const FUSION_BLACKLIST = [
  '0x545261dD1e014F637C94c087f0b56ae0E5A86Ba9',
  '0xd2f76ce8a2405465e20009ce25f5f514d4269806',
  '0x0a6767bFD8025BD4de695a5623C2Ac5FFC4B48b5',
  '0xa4fe7A704256f0fe9B1105CCAA16641fB23b8DAb',
  '0xd166b09998645c9e130a2Dd2c12133271D50687c',
  '0xCE2Bc4BEb587dE22C5D1B2099e0605d92BE2E9eF',
  '0x6A2235B4BD501090D7519F26804747b8e2614E05',
  '0x6374A8ae8FBA81518F2C25B5C9f182753408E595',
  '0x08a07bf5b971b02b1322f527dfe19ad60cba3cad',
  '0x2f02B38c883c4D573A37b241798bd34E0167F706',
  '0x49f49a7f99fb47589b2411e258c514f79d6685d7',
];
